export default "__VITE_ASSET__5JltbeG$__"